<template>
	<v-dialog v-model="dialogSwitch" persistent scrollable width="700">
		<v-form v-model="formData['valid']" class="mb-3" @submit.prevent="updateProductSKU">
			<v-card>
				<v-card-title id="heading" class="d-flex justify-space-between">
					<h4>Update Device</h4>
					<v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
				</v-card-title>

				<v-container>
					<v-alert v-if="errors.length"
					         class="mb-3 bg-error"
					         closable close-label="Close Alert"
					         density="compact" variant="tonal">
						<p v-for="error in errors">{{ error }}</p>
					</v-alert>

					<v-row>
						<v-col cols="12" sm="12">
							<v-text-field v-model="formData['label']" autofocus
							              :rules="[vRules.required, vRules.maxLength(64)]"
							              density="compact" label="Label"/>
						</v-col>
					</v-row>
				</v-container>

				<v-card-actions class="px-4 d-flex justify-end">
					<v-btn size="small" type="button"
					       @click="$emit('update:modelValue',false)">
						Close
					</v-btn>
					<v-btn color="primary" size="small" type="submit">Update</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
	modelValue: Boolean,
	deviceGroup: {
		type: Object
	}
});

const formData = reactive({
	valid: false,
	label: props.deviceGroup.label ?? null,
});
const emits = defineEmits(['update:modelValue', 'updateDeviceGroup']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const updateProductSKU = () => {
	if (formData.valid) {
		errors.value = [];
        send('put', `device-groups/${props.deviceGroup.id}`, formData)
            .then((response) => {
				snackbar.showSnackbar(response.data.message);
				if (response.data.success) {
					emits('updateDeviceGroup', response.data.data.device_group);
					emits('update:modelValue', false);
				}
			})
			.catch(function (errorResponse) {
				if (errorResponse.response.data.errors) {
					let validationErrors = errorResponse.response.data.errors;
					Object.keys(validationErrors).forEach((key) => {
						errors.value.push(validationErrors[key][0]);
					});
				} else if (errorResponse.response.data.message) {
					errors.value.push(errorResponse.response.data.message);
				}
				snackbar.showSnackbar('Something went wrong', 'error');
				document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
			})
	}
}

</script>
